/* 29/8/2026 — GẮN LÊN `window` VÀ CHỊU ĐƯỢC NẠP HAI LẦN.

   `share.js` mở đầu bằng `class ShareButton extends DetailsDisclosure`. Nếu file
   này chưa chạy thì dòng đó ném `ReferenceError: DetailsDisclosure is not defined`
   NGAY DÒNG ĐẦU, và `share-button` không bao giờ được định nghĩa. Xem bản vá kèm
   theo ở main-product / main-article / featured-product: ba chỗ đó nạp `share.js`
   trong layout `theme.liquid`, mà layout ấy KHÔNG hề nạp file này (chỉ
   `layout/wbquickview.liquid` nạp).

   Hai thay đổi, cả hai đều để bản vá kia an toàn:
   · gắn lên `window` — `share.js` tham chiếu trần `DetailsDisclosure`, và tên
     toàn cục đặt bằng thuộc tính của `window` thì tham chiếu trần vẫn phân giải
     được. Khai bằng `class` trần trong khối `if` là biến CHẶN KHỐI, share.js sẽ
     không thấy.
   · chịu được nạp hai lần — hai section cùng nạp trên một trang (featured-product
     đặt trong template sản phẩm chẳng hạn) thì bản cũ ném hai lỗi: `class` khai
     lại (`Identifier ... has already been declared`) và `customElements.define`
     trùng tên. Cả hai đều giết nốt phần còn lại của file.                       */
if (!window.DetailsDisclosure) {
  window.DetailsDisclosure = class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');

      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      })
    }

    close() {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
  };
}

if (!customElements.get('details-disclosure')) {
  customElements.define('details-disclosure', window.DetailsDisclosure);
}
